import { FormProvider, useForm } from 'react-hook-form';
import { InputHookForm } from '../../Common/Form/input-with-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { metadataSchema } from './schema';
import { MenuHookForm } from '../../Common/Form/menu-with-hook-form';
import Button from '../../Button';
import { useEffect, useState } from 'react';
import ArrowRightIcon from '../../../assets/arrow-right-white-icon.svg';
import { TextAreaHookForm } from '../../Common/Form/textarea-hook-form';
import FormInputCounter from './InputCountCharacter/form-input-counter.component';
import { createRequest, fetchRequestContentTypes } from '../../../apis/request.api';
import { useNavigate } from 'react-router-dom';
import CreateRequestModal from './create-request-modal.component';
import { useToast } from '@chakra-ui/react';
import { TooltipComponent } from '../../Tooltip';
import InformIcon from '../../../assets/inform-gray-icon.svg';
import ToastBtnMessage from '../../ToastBtnMessage';
import { DataLayer } from '../../../utils/data-layer';
import { useAtom } from 'jotai';
import { profileAtom } from '../../Settings/atom';

const EQUITY_PERCENTAGE_TOOLTIP =
  "Share a percentage of the article's equity with the contributor. The contributor can also propose a different percentage in the form.";

const RequestEnterMetadataComponent = () => {
  const [listContentType, setListContentType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState('');
  const [createdRequestId, setCreatedRequestId] = useState();
  const toast = useToast();
  const [profile] = useAtom(profileAtom);

  const navigate = useNavigate();

  const methods = useForm({
    resolver: yupResolver(metadataSchema)
  });

  const onSubmit = async (formValue) => {
    try {
      // Track content request event
      const selectedContentTypes = formValue.contentTypeIds.map((contentType) => contentType.name);
      const contentTypeString = selectedContentTypes.join(', ');
      const username = profile?.username;

      DataLayer.trackContentRequest(contentTypeString, username);

      await createRequest({
        contentTypeIds: formValue.contentTypeIds.map((contentType) => contentType.id),
        description: formValue.description,
        equityPercentage: Number(formValue.equityPercentage),
        title: formValue.title
      }).then((response) => {
        setCreatedRequestId(response?.id);
        setModal('create-success');
      });
    } catch (error) {
      toast({
        render: () => (
          <ToastBtnMessage
            title={'Create request failed'}
            isError={true}
            color="jet-black"
            isHiddenButton
          />
        ),
        status: 'error',
        duration: 2000,
        isClosable: true,
        position: 'top-right'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBackToRequestScreen = () => {
    navigate('/article/manage?tab=requests');
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const topicsRes = await fetchRequestContentTypes();
        if (topicsRes) setListContentType(topicsRes);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="mb-[90px] md:mb-[200px] max-w-[592px] mx-auto">
      <div>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-4 w-full">
              <FormInputCounter
                name="title"
                placeholder="ex.: Image of a dog"
                label="Request title"
                maxLength={100}
                component={InputHookForm}
              />
              <FormInputCounter
                component={TextAreaHookForm}
                css={{
                  '&::-webkit-scrollbar': {
                    display: 'none'
                  }
                }}
                name="description"
                placeholder="Write description"
                label="Description"
                maxLength={2000}
              />
              {/* Equitity Percentage */}
              <div>
                <div className="flex items-center mb-[12px]">
                  <p className="mr-1">Equity percentage</p>
                  <TooltipComponent Icon={InformIcon} description={EQUITY_PERCENTAGE_TOOLTIP} />
                </div>
                <FormInputCounter
                  name="equityPercentage"
                  placeholder="ex: 2%, 5%..."
                  label=""
                  component={InputHookForm}
                  isShowRange={false}
                />
              </div>
              <MenuHookForm
                name="contentTypeIds"
                label="Content Type"
                isShowCheckBox
                placeholder="Image, Video"
                data={listContentType || []}
              />
            </div>
            <div className="bg-white flex flex-row gap-3 justify-end border-t-[1px] border-solid border-04-anti-flash-white fixed left-0 bottom-0 z-20 p-4 w-full">
              <Button variant="outline" onClick={handleBackToRequestScreen}>
                Discard
              </Button>
              <Button type="submit" isLoading={loading}>
                Submit
                <img src={ArrowRightIcon} alt="" className="ml-2" />
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
      {modal === 'create-success' ? (
        <CreateRequestModal
          isOpen
          title="Share Your Request"
          shareUrl={`${process.env.REACT_APP_NEWSLETTER_URL}request/${createdRequestId}/detail`}
          onClose={handleBackToRequestScreen}
          onSubmit={handleBackToRequestScreen}
          titleBtn="Done"
        />
      ) : null}
    </div>
  );
};

export default RequestEnterMetadataComponent;
